import { connect } from "react-redux";

import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import {
    FormActionHandlerExecutionInjectableProps,
    withFormActionHandlerExecution,
} from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";
import { ActionContainerProps } from "../Common/ActionContainerProps";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";
import { withControlDebugInfo } from "../../withControlDebugInfo";

import { KebabAction } from "./KebabAction";

export interface KebabActionContainerProps extends ActionContainerProps, FormActionHandlerExecutionInjectableProps {
    disabled?: boolean;
    disabled2?: EvaluableProp<boolean>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
}

const mapStateToProps = (state: FullFormState, ownProps: KebabActionContainerProps) => {
    const { disabled2, processEvaluableProp } = ownProps;
    if (isNotNullOrUndefined(disabled2)) {
        return {
            disabled: processEvaluableProp(state, disabled2),
        };
    }
    return {};
};

const mapDispatchToProps = (_: CandyDispatch, ownProps: KebabActionContainerProps) => ({
    onClick: async (event: unknown) => {
        // Эта штука нужна ибо ниже выставляется __MENU_ITEM__ = true
        // react-ui при этом кинет нам сюда onClick и корректно закроет Menu
        ownProps.onClick?.(event);
        if (ownProps.onActionClick != undefined) {
            await ownProps.executeFormActionHandler(ownProps.onActionClick);
        }
    },
});

export const KebabActionContainer = withResolvePaths(
    withFormActionHandlerExecution(
        withViewModelSelect(
            withEvaluators(connect(mapStateToProps, mapDispatchToProps)(withControlDebugInfo(KebabAction)))
        )
    )
);

// @ts-ignore
KebabActionContainer.__MENU_ITEM__ = true;

// @ts-ignore эта пропертя заставляет react-ui склонировать всех детей ниже
//  и передать им в props свойства onMouseEnter/onMouseLeave что позволяет управлять ховером
KebabActionContainer.__KONTUR_REACT_UI__ = "MenuItem";
